<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
import Vue from 'vue';
import { getUrlParamsNew, isHarmonyHllApp } from '@/commons/tools';
import { mapMutations } from 'vuex';

import {
  Form,
  Field,
  CellGroup,
  Cell,
  Tabs,
  Tab,
  Popup,
  Picker,
  DatetimePicker,
  Button,
  Loading,
  List,
  PullRefresh,
  Divider,
  Checkbox,
  Overlay,
  Sticky,
  Swipe,
  SwipeItem,
  Step,
  Steps,
  Toast,
  Dialog,
} from 'vant';
import { sendEvent } from './commons/monitor.js';
import { channelTypeMap } from './module/coupon/util/platforms';


Vue.use(Form);
Vue.use(Field);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(DatetimePicker);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Button);
Vue.use(Loading);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Divider);
Vue.use(Checkbox);
Vue.use(Overlay);
Vue.use(Sticky);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Toast);
Vue.use(Dialog);

export default {
  name: 'App',
  data() {
    return {
      keepAlive: [],
    };
  },
  computed: {},
  created() {
    this.andriodInputBug();
    // this.iosInputBug();
  },
  mounted() {
    if (/Android/gi.test(navigator.userAgent)) {
      window.addEventListener('resize', function() {
        if (
          document.activeElement.tagName == 'INPUT' ||
          document.activeElement.tagName == 'TEXTAREA'
        ) {
          window.setTimeout(function() {
            if (document.activeElement &&
              document.activeElement.scrollIntoViewIfNeeded
            ) {
              document.activeElement.scrollIntoViewIfNeeded();
            }
          }, 0);
        }
      });
    }

    const { token } = getUrlParamsNew();
    token && this.setToken(token);
    this.validateHarmonyChannelType();
  },
  methods: {
    andriodInputBug() {
      if (/Android/gi.test(navigator.userAgent)) {
        window.addEventListener('resize', function() {
          if (
            document.activeElement.tagName == 'INPUT' ||
            document.activeElement.tagName == 'TEXTAREA'
          ) {
            window.setTimeout(function() {
              if (document.activeElement &&
                document.activeElement.scrollIntoViewIfNeeded
              ) {
                document.activeElement.scrollIntoViewIfNeeded();
              }
            }, 100);
          }
        });
      }
    },
    iosInputBug() {
      /iphone|ipod|ipad/i.test(navigator.appVersion) &&
        document.addEventListener(
          'blur',
          e => {
            ['input', 'textarea'].indexOf(e.target.localName) > -1 &&
              document.body.scrollIntoView(false);
          },
          true
        );
    },
    validateHarmonyChannelType() {
      try {
        const params = getUrlParamsNew();
        const channelType = params.channel_type || params.channelType;
        const isHarmony = isHarmonyHllApp();
        console.log('isHarmony,channelType:', isHarmony, channelType)
        if (isHarmony && channelType !== channelTypeMap.HUOYUN_HONGMENG) {
          sendEvent('@channelTypeError', {
            referrer: document.referrer,
            ua: navigator.userAgent
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    ...mapMutations({
      setToken: 'saveToken',
      setMd5: 'saveDriverMd5',
      setDriverFid: 'saveDriverFid',
    }),
  },
};
</script>

<style lang="less" scoped>
#app {
  width: 100%;
  min-height: 100vh;
}
</style>
